import cx from "classnames";
import { DatePicker } from "react-datepicker";
import { type Control, Controller, FieldValues, Path } from "react-hook-form";

import formStyles from "@/styles/form.module.scss";

interface PartFormDatePickerProps<TFieldValues extends FieldValues> {
  id?: string;
  name: Path<TFieldValues>;
  control: Control<TFieldValues>;
  placeholder?: string;
  dateFormat?: string;
  disabled?: boolean;
}

const PartFormDatePicker = <TFieldValues extends FieldValues>(
  props: PartFormDatePickerProps<TFieldValues>,
) => {
  const { control, name, placeholder, dateFormat, disabled } = props;
  return (
    <Controller
      control={control}
      name={name}
      // @ts-expect-error // TODO Fix def
      defaultValue={""}
      render={({ field, fieldState: { error } }) => (
        <DatePicker
          id={props.id}
          className={cx(formStyles.formInput, {
            [formStyles.invalid]: !!error,
          })}
          placeholderText={placeholder || "Select Date"}
          onChange={date => {
            if (!date) return field.onChange(null);

            const y = date.getFullYear();
            const m = String(date.getMonth() + 1).padStart(2, "0");
            const d = String(date.getDate()).padStart(2, "0");

            const result = `${y}-${m}-${d}`;
            field.onChange(result);
          }}
          onBlur={field.onBlur}
          selected={parseLocalDate(field.value)}
          dateFormat={dateFormat}
          disabled={disabled}
        />
      )}
    />
  );
};

export default PartFormDatePicker;

export function parseLocalDate(dateString?: string | null): Date | null {
  if (!dateString) return null;
  if (typeof dateString !== "string") return dateString as unknown as Date;

  const parts = dateString.split("-");
  if (parts.length !== 3) return null;

  const [y, m, d] = parts.map(Number);

  return new Date(y, m - 1, d);
}

export const dateFormat = "MMM d, yyyy (EEE)";
